module.exports = __webpack_public_path__ + "img/worksbot_img20021102.3f89b5bb.jpg";